import React from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom/cjs/react-router-dom.min';
import { Mixpanel } from '../../redux/Mixpanel';
import UploadFile from './UploadFile';
import { Typeahead } from 'react-bootstrap-typeahead';
import { Link } from 'react-router-dom';

import {
    Button,
    Row,
    Col,
    Form,
    FormFeedback,
    FormGroup,
    Input,
    Label,
    InputGroup,
    Container,
    UncontrolledTooltip
} from 'reactstrap';

import CustomInput from '../../components/CustomInput';
import { colorTheme, OCCUPANT_TYPE, UNIFORM_RESOURCE_LOCATORS } from '../../utils/constants';
import CustomLabel from '../../components/CustomLabel';
import ShowMoreButton from './ShowMoreButton';
import { createPenaltyDays } from '../../utils';
import {
    check_empty_field,
    check_if_number,
    check_valid_email,
    check_phone_number,
    check_kra_pin,
    check_percentage,
    check_penalty_day_of_month,
    clear_error_from_field
} from './validationChecks';

import {
    addTenant,
    updateTenant,
    deleteTenant,
    showLoading,
    showFeatureComingSoon,
    downloadFile,
    fetchTenantData,
    fetchPropertiesUnitsTenants,
    fetchOptions
} from '../../redux/actions';

import CustomPropertySelect from '../../components/CustomPropertySelect';
import PhoneNumberFormatText from '../../components/PhoneNumberFormat';
import FormattedPhoneInput from '../../components/HandlePhoneNumbers/PhoneInputWithValidation';
import fileDownload from 'js-file-download';
import { IonButton, IonIcon, IonInput } from '@ionic/react';
import { addOutline, arrowBackOutline, arrowForwardOutline, informationCircleOutline, refreshOutline, trashOutline } from 'ionicons/icons';
import { Capacitor } from '@capacitor/core';
import { Filesystem, Directory } from '@capacitor/filesystem';
import { Share } from '@capacitor/share';
import { Toast } from '@capacitor/toast';
import writeBlob from 'capacitor-blob-writer';


const mapStateToProps = state => {
    return {
        properties: state.properties,
        units: state.units,
        tenants: state.tenants,
        options: state.options
    };
}

const mapDispatchToProps = {
    addTenant,
    updateTenant,
    deleteTenant,
    showLoading,
    showFeatureComingSoon,
    downloadFile,
    fetchTenantData,
    fetchPropertiesUnitsTenants,
    fetchOptions

};

const DEPOSIT_NAME_OPTIONS = ["rent", "water", "electricity", "service charge", "other"]

class TenantForm extends React.Component {
    constructor(props) {
        super(props);
        const defaultDeposit = {name: [], amountPaid: "", amountReturned: ""}
        this.tenantPageButtonRef = React.createRef();
        let tenant = {
            propertyId: Object.values(this.props.properties).length == 1? Object.values(this.props.properties)[0].propertyId: "",
            unitId: "",
            tenantId: "",
            lastName: "",
            firstName: "",
            phoneNumber: "",
            phoneNumberFormatted: "",
            email: "",
            deposits: [{...defaultDeposit}],
            moveInDate: "",
            moveOutDate: "",
            leaseStartDate: "",
            leaseEndDate: "",
            penaltyType: "",
            fixedPenaltyAmount: 0.00,
            percentagePenaltyAmount: 0.00,
            automaticallyPenalize: false,
            penaltyDayOfMonth: "",
            notes: "",
            accountId: "",
            taxPin: "",
            nationalIdNumber: "",
            archived: false,
            file: null,
            fileName: "",
            fileId: "",
            updateFile: false,
            selectedUnits: [],
            otherPhoneNumbers:[{firstName: "", phoneNumber: "", phoneNumberFormatted: ""}],
            nextOfKin:[{name: "", phoneNumber: "", phoneNumberFormatted: "", relationship: "", information: ""}],
            bankPayerNames: [""],
            showOptionalFields: false,
            showAlert: false,
            showUploadSpreadSheet: props.showUploadSpreadSheet == false ? false : true
        };
        this.state = {
            ...tenant,
            properties: [],
            penaltyDays: [],
            depositNameOptions: DEPOSIT_NAME_OPTIONS.map(this.getDepositName.bind(this)),
            numErrors: 0,
            errors: {
                lastName: "",
                firstName: "",
                phoneNumber: "",
                phoneNumberFormatted: "",
                email: "",
                moveInDate: "",
                moveOutDate: "",
                leaseStartDate: "",
                leaseEndDate: "",
                notes: "",
                fixedPenaltyAmount: "",
                percentagePenaltyAmount: "",
                penaltyDayOfMonth: "",
                taxPin: "",
                accountId: "",
                nationalIdNumber: "",
                deposits: tenant.deposits.map( () => ({name: "", amountPaid: "", amountReturned: ""})),
                otherPhoneNumbers: tenant.otherPhoneNumbers.map(
                    ()=> ({firstName: "", phoneNumber: "", phoneNumberFormatted: ""})
                ),
                nextOfKin: tenant.nextOfKin.map(() => ({name: "", phoneNumber: "", phoneNumberFormatted: "", relationship: "", information: ""}))
            }
        };
        this.penaltyDays = [];
        this.handleChange = this.handleChange.bind(this);
    }

    async fetchInitialData() {
        await Promise.all([
          (async () => {
            if (_.isEmpty(this.props.properties) || _.isEmpty(this.props.units)) {
              this.props.showLoading(true);
              await this.props.fetchPropertiesUnitsTenants();
            }
          })(),
            (async () => {
                if (_.isEmpty(this.props.options)) {
                this.props.showLoading(true);
                await this.props.fetchOptions();
                }
            })()
        ]);
      }

    async componentDidMount(){
        await this.fetchInitialData();

        const { tenantDetails } = this.props;

        let tenantProps = null;
        let depositsArray = [];
        let moveInDate = null;
        let moveOutDate = null;
        let leaseStartDate = null;
        let leaseEndDate = null;
        let depositJson = null;
        let propertyId = Object.values(this.props.properties).length == 1? Object.values(this.props.properties)[0].propertyId: "";

        this.handleTutorialAlert();

        if (tenantDetails) {
            let tenantId = tenantDetails.tenantId;

            tenantProps = null;

            if (_.isEmpty(this.props.tenants)) {
              const result = await this.props.fetchTenantData(tenantId);
              tenantProps = result?.payload?.tenantData ?? null;
            } else {
              tenantProps = this.props.tenants?.[tenantId] ?? null;
            }

            if (tenantProps) {
              depositJson = tenantProps?.depositJson;

            if (depositJson) {
                try {
                  depositsArray = JSON.parse(depositJson);
                } catch (error) {
                  console.error("Error parsing depositJson:", error);
                }
            } else {
                depositsArray = tenantProps.deposits || [];
            }

              moveInDate = tenantProps?.moveInDate ? new Date(tenantProps.moveInDate) : null;
              moveOutDate = tenantProps?.moveOutDate ? new Date(tenantProps.moveOutDate) : null;
              leaseStartDate = tenantProps?.leaseStartDate ? new Date(tenantProps.leaseStartDate) : null;
              leaseEndDate = tenantProps?.leaseEndDate ? new Date(tenantProps.leaseEndDate) : null;

            }
          }


        // No longer needed since we are using the tenantDetails prop
        // let propertyId = searchParams.has('propertyId') ? searchParams.get('propertyId') : this.state.propertyId;
        // let unitId = searchParams.has('unitId') ? searchParams.get('unitId') : this.state.unitId;

        const nextOfKinRaw = tenantProps && tenantProps.nextOfKin;
        let nextOfKinArray = [];
        if (Array.isArray(nextOfKinRaw)) {
            nextOfKinArray = nextOfKinRaw;
        } else if (typeof nextOfKinRaw === 'string' && nextOfKinRaw.length > 0) {
            try { nextOfKinArray = JSON.parse(nextOfKinRaw) || []; } catch (e) { nextOfKinArray = []; }
        }

        await new Promise((resolve) => {
            this.setState((prevState) => ({
            propertyId: tenantProps ? tenantProps.propertyId : propertyId,
            unitId: tenantProps ? tenantProps.unitId : unitId,
            tenantId: tenantProps ? tenantProps.tenantId : this.state.tenantId,
            lastName: tenantProps ? tenantProps.lastName : this.state.lastName,
            firstName: tenantProps ? tenantProps.firstName : this.state.firstName,
            phoneNumber: tenantProps ? tenantProps.phoneNumber : this.state.phoneNumber,
            phoneNumberFormatted: tenantProps ? tenantProps.phoneNumber : this.state.phoneNumberFormatted,
            email: tenantProps ? tenantProps.email : this.state.email,
            moveInDate: tenantProps && moveInDate ? moveInDate.toISOString().split('T')[0] : this.state.moveInDate,
            moveOutDate: tenantProps && moveOutDate ? moveOutDate.toISOString().split('T')[0] : this.state.moveOutDate,
            leaseStartDate: tenantProps && leaseStartDate ? leaseStartDate.toISOString().split('T')[0] : this.state.leaseStartDate,
            leaseEndDate: tenantProps && leaseEndDate ? leaseEndDate.toISOString().split('T')[0] : this.state.leaseEndDate,
            penaltyType: tenantProps ? tenantProps.penaltyType : this.state.penaltyType,
            fixedPenaltyAmount: tenantProps ? tenantProps.fixedPenaltyAmount : this.state.fixedPenaltyAmount,
            percentagePenaltyAmount: tenantProps ? tenantProps.percentagePenaltyAmount : this.state.percentagePenaltyAmount,
            automaticallyPenalize: tenantProps ? tenantProps.automaticallyPenalize : this.state.automaticallyPenalize,
            penaltyDayOfMonth: tenantProps ? tenantProps.penaltyDayOfMonth : this.state.penaltyDayOfMonth,
            notes: tenantProps ? tenantProps.notes : this.state.notes,
            accountId: tenantProps ? tenantProps.accountId : this.state.accountId,
            taxPin: tenantProps ? tenantProps.taxPin : this.state.taxPin,
            nationalIdNumber: tenantProps ? tenantProps.nationalIdNumber : this.state.nationalIdNumber,
            archived: tenantProps ? tenantProps.archived : this.state.archived,
            fileName: tenantProps && tenantProps.upload ? tenantProps.upload.file : this.state.fileName,
            fileId: tenantProps && tenantProps.upload ? tenantProps.upload.id : this.state.fileId,
            deposits: tenantProps && depositsArray.length > 0 ? depositsArray.map(this.getDeposit.bind(this)) : this.state.deposits,
            otherPhoneNumbers: tenantProps  && tenantProps.otherPhoneNumbers.length > 0 ? [...tenantProps.otherPhoneNumbers] : this.state.otherPhoneNumbers,
            nextOfKin: (() => {
                const raw = tenantProps && tenantProps.nextOfKin;
                if (!raw) return this.state.nextOfKin;
                if (Array.isArray(raw)) return raw;
                if (typeof raw === 'string' && raw.length > 0) {
                    try { return JSON.parse(raw) || this.state.nextOfKin; } catch (e) { return this.state.nextOfKin; }
                }
                return this.state.nextOfKin;
            })(),
            bankPayerNames: tenantProps && tenantProps.bankPayerNames.length > 0 ? [ ...tenantProps.bankPayerNames ] : this.state.bankPayerNames,
            penaltyDays: createPenaltyDays(),
            properties: Object.values(this.props.properties),
            errors: {
                ...prevState.errors,
                deposits: tenantProps && depositsArray.length > 0 ? depositsArray.map( () => ({name: "", amountPaid: "", amountReturned: ""})) : prevState.errors.deposits,
                otherPhoneNumbers: tenantProps && tenantProps.otherPhoneNumbers.length > 0 ? tenantProps.otherPhoneNumbers.map(
                    ()=> ({firstName: "", phoneNumber: "", phoneNumberFormatted: ""})) : prevState.errors.otherPhoneNumbers,
                nextOfKin: (() => {
                    const raw = tenantProps && tenantProps.nextOfKin;
                    if (Array.isArray(raw) && raw.length > 0) {
                        return raw.map(() => ({name: "", phoneNumber: "", phoneNumberFormatted: "", relationship: "", information: ""}))
                    }
                    if (typeof raw === 'string' && raw.length > 0) {
                        try {
                            const arr = JSON.parse(raw);
                            if (Array.isArray(arr) && arr.length > 0) {
                                return arr.map(() => ({name: "", phoneNumber: "", phoneNumberFormatted: "", relationship: "", information: ""}))
                            }
                        } catch (e) { /* noop */ }
                    }
                    return prevState.errors.nextOfKin || [];
                })()
            }
        }), resolve);
        });

        this.setSelectedUnits(tenantProps ? tenantProps.propertyId : propertyId);
    }

    handleTutorialAlert() {
        const searchParams = new URLSearchParams(this.props.location.search);
        const showAlert = searchParams.has('tutorial');
        this.setState({ showAlert });
      }

    componentDidUpdate(prevProps, prevState) {
        if (!prevProps.tenantId && this.props.tenantId) {
            //added this so the users are shown the view tenant button via scrolling to it which they would have otehrwise missed
          this.scrollToTenantPageButton();
        }
      }

      scrollToTenantPageButton() {
        if (this.tenantPageButtonRef.current) {
          this.tenantPageButtonRef.current.scrollIntoView({ behavior: 'auto' });
        }
      }

    getDeposit(item, index){
        return {
            name: [this.getDepositName(item.name)],
            amountPaid: item.amountPaid? item.amountPaid.toString() : "",
            amountReturned: item.amountReturned? item.amountReturned.toString() : ""
        }
    }


    isValidOtherPhoneNumbers(){
        let foundError = false;
        this.setState(prevState => {
            const otherPhoneNumbers = prevState.otherPhoneNumbers.map((tenant_no) => {
                let firstNameError = "";
                let phoneNumberError = "";
                if(!(tenant_no.firstName.length == 0 || tenant_no.phoneNumber.length == 0)){
                    firstNameError = check_empty_field(tenant_no.firstName)
                    phoneNumberError = check_empty_field(tenant_no.phoneNumber) || check_phone_number(tenant_no.phoneNumber)
                }
                if(!foundError){
                    foundError = firstNameError.length > 0 || phoneNumberError.length > 0
                }
                return {
                    firstName: firstNameError,
                    phoneNumber: phoneNumberError
                }
            });
            return {
                errors: {
                    ...prevState.errors,
                    otherPhoneNumbers
                }
            }
        });
        return !foundError;
    }

    isValidNextOfKin(){
        let foundError = false;
        this.setState(prevState => {
            const nextOfKinErrors = (prevState.nextOfKin || []).map((nok) => {
                let nameError = "";
                let phoneNumberError = "";
                const hasAny = ((nok && nok.name) ? nok.name.length : 0) > 0 || ((nok && nok.phoneNumber) ? nok.phoneNumber.length : 0) > 0;
                if (hasAny) {
                    nameError = check_empty_field(nok?.name || "");
                    phoneNumberError = check_empty_field(nok?.phoneNumber || "") || check_phone_number(nok?.phoneNumber || "");
                }
                if(!foundError){
                    foundError = nameError.length > 0 || phoneNumberError.length > 0;
                }
                return {
                    name: nameError,
                    phoneNumber: phoneNumberError,
                    phoneNumberFormatted: "",
                    relationship: "",
                    information: ""
                };
            });
            return {
                errors: {
                    ...prevState.errors,
                    nextOfKin: nextOfKinErrors
                }
            };
        });
        return !foundError;
    }

    async validateInput(name, value) {
        let val = String(value);
        let autoPenalizeChecked = value;
        let isValid = true;
        let checks = [];

        switch (name) {
            case "firstName":
                checks = [check_empty_field];
                break;
            case "lastName":
                checks = [check_empty_field];
                break;
            case "email":
                checks = [check_valid_email];
                break;
            case "phoneNumber":
                checks = [check_empty_field, check_phone_number];
                break;
            case "taxPin":
                checks = [check_kra_pin]
                break;
            case "fixedPenaltyAmount":
                checks = [check_if_number];
                break;
            case "percentagePenaltyAmount":
                checks = [check_if_number, check_percentage]
                break
            case "automaticallyPenalize":
                val = this.state.penaltyDayOfMonth
                name = "penaltyDayOfMonth"
                if(autoPenalizeChecked){
                    checks = [check_penalty_day_of_month]
                }else{
                    checks = [clear_error_from_field]
                }
                break
            case "penaltyDayOfMonth":
                if(this.state.automaticallyPenalize){
                    checks = [check_penalty_day_of_month]
                }else{
                    checks = [clear_error_from_field]
                }
                break
            default:
                break;

        }

        this.setState((prevState) => {
            let errors = { ...prevState.errors };
            let numErrors = prevState.numErrors;
            for (let index in checks) {
                let previousError = prevState.errors[name];
                errors[name] = checks[index](val);

                if (errors[name].length > 0) {
                    if (previousError.length == 0) {
                        numErrors += 1
                    }
                    isValid = false;
                    break;
                } else if (previousError.length > 0) {
                    numErrors -= 1
                }
            }
            return {
                errors,
                numErrors
            };
        });
        return isValid;
    }

    handleChange(event) {
        const target = event.target;
        let name = target.name;
        let val = target.type === 'checkbox' ? target.checked : target.value;
        this.setState({ [name]: val });

        this.validateInput(name, val);
    }

    handleSelectProperty(event){
        this.handleChange(event);
        const newPropertyId = event.target.value;
        this.setSelectedUnits(newPropertyId);
    }

    setSelectedUnits(propertyId){
        let selectedUnits = [];
        let occupiedUnits = [];
        if(propertyId){
            for (let unit of Object.values(this.props.units)){
                if (unit.propertyId == propertyId){
                    if(unit.occupied){
                        occupiedUnits.push(unit);
                    }else{
                        selectedUnits.push(unit);
                    }
                }
            }
            selectedUnits = [ ...selectedUnits, ...occupiedUnits];
        }
        this.setState({selectedUnits});
    }


    async handleSubmit(event) {
        event.preventDefault();
        let fields = ["firstName", "lastName", "phoneNumber", "email", "penaltyDayOfMonth"];
        let results = [];
        let field;
        for (field of fields) {
            let isValid = await this.validateInput(field, this.state[field])
            results.push(isValid);
        }
        let invalid_fields = results.filter((x) => !x);

        const isValidPhoneNumbers = this.isValidOtherPhoneNumbers();
        const isValidDeposits = this.isValidDeposits();
        const isValidNextOfKin = this.isValidNextOfKin();
        if (this.state.propertyId != "" && this.state.unitId != "" &&
            invalid_fields.length == 0 && isValidPhoneNumbers && isValidDeposits && isValidNextOfKin
        ) {
            const deposits = this.state.deposits.filter(
                deposit => deposit.name.length > 0 && deposit.amountPaid.length > 0
            ).map(deposit => ({
                name: deposit.name[0].id,
                amountPaid: deposit.amountPaid,
                amountReturned: deposit.amountReturned
            }));

            let tenant_obj = {
                propertyId: this.state.propertyId,
                unitId: this.state.unitId,
                firstName: this.state.firstName,
                lastName: this.state.lastName,
                phoneNumber: this.state.phoneNumberFormatted || this.state.phoneNumber,
                email: this.state.email,
                taxPin: this.state.taxPin,
                deposits,
                moveInDate: this.state.moveInDate ? this.state.moveInDate.slice(0, 10) : "",
                moveOutDate: this.state.moveOutDate ? this.state.moveOutDate.slice(0, 10) : "",
                leaseStartDate: this.state.leaseStartDate ? this.state.leaseStartDate.slice(0, 10) : "",
                leaseEndDate: this.state.leaseEndDate ? this.state.leaseEndDate.slice(0, 10) : "",
                penaltyType: this.state.penaltyType ? this.state.penaltyType.toUpperCase() : "",
                fixedPenaltyAmount: this.state.fixedPenaltyAmount,
                percentagePenaltyAmount: this.state.percentagePenaltyAmount,
                automaticallyPenalize: this.state.automaticallyPenalize,
                penaltyDayOfMonth: this.state.penaltyDayOfMonth? this.state.penaltyDayOfMonth : "0",
                notes: this.state.notes,
                archived: this.state.archived,
                fileUpload: this.state.file,
                accountId: this.state.accountId,
                nationalIdNumber: this.state.nationalIdNumber,
                updateFile: this.state.updateFile,
                otherPhoneNumbers: this.state.otherPhoneNumbers,
                nextOfKin: this.state.nextOfKin,
                bankPayerNames: this.state.bankPayerNames
            }
            this.props.showLoading(true);
            let result;
            try {
                if (!this.state.tenantId) {
                    result = await this.props.addTenant(tenant_obj);
                    if (result && result.payload) {
                        let tenantId = result.payload.tenantId || "";
                        let accountId = result.payload.accountId || "";
                        this.setState({
                            tenantId,
                            accountId
                        });
                    }
                } else {
                        result = await this.props.updateTenant({
                        ...tenant_obj,
                        tenantId: this.state.tenantId
                    });
                }
                if (result && result.payload) {
                    this.setState({ fileUpload: null });
                }
                this.setSelectedUnits(this.state.propertyId);
            } finally {
                this.props.showLoading(false);
            }
        }
        Mixpanel.track("Tenant form: submit");
    }

    setTenantValues(propertyId = "", unitId = "", tenantId = "", firstName = "",
        lastName = "", phoneNumber = "+254", phoneNumberFormatted="",
        email = "", moveInDate = "", moveOutDate = "", leaseStartDate = "", leaseEndDate = "",
        notes = "", accountId = "", nationalIdNumber="",  taxPin="",
        otherPhoneNumbers = [{firstName: "", phoneNumber: "+254", phoneNumberFormatted: ""}],
        nextOfKin = [{name: "", phoneNumber: "", phoneNumberFormatted: "", relationship: "", information: ""}],
        deposits = [{name: [], amountPaid: "", amountReturned: ""}], file = null, fileId = "",
        fileName = "", penaltyType = "", fixedPenaltyAmount = 0.00, percentagePenaltyAmount = 0.00,
        automaticallyPenalize = false, penaltyDayOfMonth = "", bankPayerNames = [""]) {
        window.scrollTo(0, 0);
        this.setState({
            propertyId, unitId, tenantId, firstName, lastName,
            phoneNumber, phoneNumberFormatted, email, moveInDate, moveOutDate, notes, leaseStartDate, leaseEndDate,
            accountId, nationalIdNumber, taxPin, otherPhoneNumbers, nextOfKin, deposits, file, fileId, fileName,
            penaltyType, fixedPenaltyAmount, percentagePenaltyAmount, automaticallyPenalize, penaltyDayOfMonth, bankPayerNames
        });
    }

    async handleDownloadFile() {
        if (this.state.fileName && this.state.fileId) {
            this.props.showLoading(true);
            Mixpanel.track("form: download file");
            try {
                await this.props.downloadFile({
                    itemType: "tenant",
                    fileId: this.state.fileId,
                    fileName: this.state.fileName
                });
            } finally {
                this.props.showLoading(false);
            }
            return;
        }

        if (this.state.file) {
            if (Capacitor.getPlatform() === 'web') {
                fileDownload(this.state.file, this.state.file.name);
                return;
            }
            try {
                const fileBlob = this.state.file;
                const targetName = this.state.file.name || 'attachment';
                if (Capacitor.getPlatform() === 'android') {
                    await writeBlob({
                        path: `Download/${targetName}`,
                        blob: fileBlob,
                        directory: Directory.ExternalStorage,
                        recursive: true,
                    });
                    try { await Toast.show({ text: `Saved to Downloads/${targetName}` }); } catch (_) {}
                } else {
                    const toBase64 = (blob) => new Promise((resolve, reject) => {
                        const reader = new FileReader();
                        reader.onload = () => {
                            const dataUrl = reader.result || '';
                            const base64 = String(dataUrl).split(',')[1] || '';
                            resolve(base64);
                        };
                        reader.onerror = reject;
                        reader.readAsDataURL(blob);
                    });
                    const base64 = await toBase64(fileBlob);
                    await Filesystem.writeFile({
                        path: targetName,
                        data: base64,
                        directory: Directory.Documents,
                    });
                    try {
                        const uri = await Filesystem.getUri({ path: targetName, directory: Directory.Documents });
                        if (uri && uri.uri) {
                            await Share.share({ title: targetName, url: uri.uri });
                        }
                    } catch (_) {}
                }
            } catch (err) {
                console.error('Mobile save failed', err);
            }
        }
    }

    handleChangeFile(event){
        this.setState({
            fileId: "",
            updateFile: true,
            file: event.target.files[0],
            fileName: event.target.files[0].name
        });
    }

    handleClose(){
        this.setState({updateFile: true, fileId: "", file: null, fileName: ""});
    }

    handleDelete(propertyId, unitId, tenantId, event) {
        event.preventDefault();
        const confirmDelete = window.confirm("Are you sure you want to delete this tenant?");
        if (confirmDelete) {
            this.props.showLoading(true);
            this.setTenantValues();
            this.props.deleteTenant(propertyId, unitId, tenantId);
            Mixpanel.track("Tenant form: delete btn");
        }
    }

    async handleBackButton() {
        const { location, history } = this.props;
        const searchParams = new URLSearchParams(location.search);
        if (history.length <= 1) {
            history.push(UNIFORM_RESOURCE_LOCATORS.tenants);
                      //added because the back button was not working when the user initially loads a link to the tenant form history has only one which is their browser home page and not our app
        } else if (searchParams.has('tutorial')) {
            history.push(UNIFORM_RESOURCE_LOCATORS.onBoarding);
        } else {
            history.goBack();
        }
      }

    handleAlertClose = () => {
        this.setState({ showAlert: false });
    }

      async handleTenantPageButton(event) {
        event.preventDefault();
        if (this.state.unitId) {
            const url = `${UNIFORM_RESOURCE_LOCATORS.tenants}?tutorial&propertyId=${this.state.propertyId}`;

            await this.props.history.push(url);
        }
      }

    handleCancelUpdate(event) {
        event.preventDefault();
        this.setTenantValues();
        Mixpanel.track("Tenant form: cancel update btn");
    }

    handleAddNewTenant(event) {
        event.preventDefault();
        //if property is one don't clear propertyID
        let propertyId = Object.values(this.props.properties).length == 1? Object.values(this.props.properties)[0].propertyId: "";
        this.setTenantValues(propertyId);
        Mixpanel.track("Tenant form: add new tenant");
    }

    handleClear(event) {
        event.preventDefault();
        this.setTenantValues();
        Mixpanel.track("Tenant form: clear tenant");
    }

    onClickUploadSpreadSheet(event) {
        event.preventDefault();
        this.props.showFeatureComingSoon();
        Mixpanel.track("Tenant form: upload spreadsheet btn");
    }

    handleChangeDate(name, value) {
        this.setState({
            [name]: value
        });
    }

    handleOtherPhoneNoFirstName(index, event){
        event.preventDefault();
        this.setState((prevState) => {
            let { otherPhoneNumbers } = prevState;
            otherPhoneNumbers[index]["firstName"] = event.target.value;
            return {otherPhoneNumbers};
        })
    }

    handleBankPayerNames(index, event){
        event.preventDefault();
        this.setState((prevState) => {
            let { bankPayerNames } = prevState;
            bankPayerNames[index] = event.target.value;
            return {bankPayerNames};
        })
    }

    renderBackButton(){
        return(
            <Row className="d-flex justify-content-start">
                <Button className="bg-white"
                    style={{borderColor: colorTheme["primary"]["700"], color: colorTheme["primary"]["700"], width:"10em"}}
                    onClick={() => this.handleBackButton()}
                    data-testid="tenantFormBackButton"
                >
                    <IonIcon icon={arrowBackOutline} className="mr-2" />
                    Back
                </Button>
            </Row>
        )
    }


    renderRequiredFields(){
        return (
            <React.Fragment>
                {/* Select Property */}
                <FormGroup row>
                    <CustomLabel sm={12} md={3} for="propertyId">
                        Select Property
                    </CustomLabel>

                    <Col style={{maxWidth: '450px'}} md={8} sm={12}>
                        <CustomInput
                            type="select"
                            id="propertyId"
                            name="propertyId"
                            className="mr-2"
                            onChange={this.handleSelectProperty.bind(this)}
                            value={this.state.propertyId}
                        >
                            <CustomPropertySelect propertiesArray={this.state.properties}/>
                        </CustomInput>
                        <small>
                        If the property is not available in the list, please go to the{" "}
                        <a className='tenant-list-row' href={UNIFORM_RESOURCE_LOCATORS.properties} style={{color: colorTheme["primary"]["700"], textDecoration: "underline", fontStyle: "italic" }}>properties page</a> to add it.
                        </small>
                    </Col>
                </FormGroup>

                {/* Select Unit */}
                <FormGroup row>
                    <CustomLabel sm={12} md={3} for="unitId">
                        Select Unit
                    </CustomLabel>

                    <Col style={{maxWidth: '450px'}} md={8} sm={12}>
                        {this.state.propertyId == "" && (<UncontrolledTooltip placement="top" target="unitId">
                            Please first select Property
                        </UncontrolledTooltip>)}
                        <CustomInput
                            type="select"
                            name="unitId"
                            id="unitId"
                            onChange={this.handleChange.bind(this)}
                            value={this.state.unitId}

                        >
                            {/* TODO: Add tooltip explaining that they should choose property first */}
                            <option key={""} value="">Select Unit</option>

                            {_.map(this.state.selectedUnits, (unit, index) => (
                                <option key={unit.unitId} value={unit.unitId}>
                                    {unit.unitName} {unit.occupied && " - occupied"}
                                </option>
                            ))}
                        </CustomInput>
                        <small>
                        If the unit is not available in the list, please go to the{" "}
                        <a className='tenant-list-row' href={UNIFORM_RESOURCE_LOCATORS.units} style={{color: colorTheme["primary"]["700"], textDecoration: "underline", fontStyle: "italic" }}>units page</a> to add it.
                        </small>
                    </Col>
                </FormGroup>

                {/* First Name */}
                <FormGroup row>
                    <CustomLabel sm={12} md={3} for="firstName">
                        First Name
                    </CustomLabel>

                    <Col style={{maxWidth: '450px'}} sm={12} md={8}>
                        <InputGroup>
                            <Input
                                id="firstName"
                                name="firstName"
                                placeholder='First Name'
                                value={this.state.firstName}
                                onChange={this.handleChange.bind(this)}
                                invalid={this.state.errors.firstName.length > 0}
                            />
                            <FormFeedback>{this.state.errors.firstName}</FormFeedback>
                        </InputGroup>
                    </Col>
                </FormGroup>

                {/* Last Name */}
                <FormGroup row>
                    <CustomLabel sm={12} md={3} for="lastName">
                        Last Name
                    </CustomLabel>

                    <Col style={{maxWidth: '450px'}} sm={12} md={8}>
                        <InputGroup>
                            <Input
                                id="lastName"
                                name="lastName"
                                placeholder='Last name ...'
                                value={this.state.lastName}
                                onChange={this.handleChange.bind(this)}
                                invalid={this.state.errors.lastName.length > 0}
                            />
                            <FormFeedback>{this.state.errors.lastName}</FormFeedback>
                        </InputGroup>
                    </Col>
                </FormGroup>

                {/* Phone Number */}
                <FormGroup row>
                    <CustomLabel sm={12} md={3} for="phoneNumber">
                        Phone Number
                    </CustomLabel>

                    <Col style={{maxWidth: '450px'}} sm={12} md={8}>
                        <InputGroup>
                        <FormattedPhoneInput
                            country={'ke'}
                            phoneNumber={this.state.phoneNumber}
                            onPhoneNumberChange={(value, formatted) => this.setState({ phoneNumber: value ,phoneNumberFormatted: formatted })}
                            fieldName={"phoneNumber"}
                            onPhoneNumberValidation={this.validateInput.bind(this)}
                        />
                        </InputGroup>
                        <PhoneNumberFormatText/>
                        <p className='text-danger'>
                            <small>
                                {this.state.errors.phoneNumber.length > 0 ? this.state.errors.phoneNumber : ""}
                            </small>
                        </p>
                    </Col>
                </FormGroup>

            </React.Fragment>
        );
    }

    renderButtons(){
        return (
            <Row className="d-flex mb-4 pb-3 border-bottom border-dark justify-content-center">
                <IonButton
                    type="submit" className="mx-2 shadow py-1"
                    size="lg"
                    id='addTenantButton'
                    style={{ width:"80%" }}
                    disabled={this.state.propertyId == "" || this.state.unitId == "" || this.state.numErrors > 0}>
                    {this.state.tenantId ?
                        <span>
                            <IonIcon icon={refreshOutline} className="mr-1" />
                            Update {this.props.options.userAccountType === OCCUPANT_TYPE ? "Tenant" : "Member"}
                        </span>
                            :
                        <span>
                            <IonIcon icon={addOutline} className="mr-2" />
                            Add {this.props.options.userAccountType === OCCUPANT_TYPE ? "Tenant" : "Member"}
                        </span>}
                </IonButton>
                {this.state.tenantId && (<IonButton
                    type="submit"
                    style={{ width: "80%" }}
                    className="mx-2 mt-3 py-1"
                    fill='outline'
                    size="lg"
                    onClick={this.handleAddNewTenant.bind(this)}
                >
                    <span><IonIcon icon={addOutline} className="mr-2" />Add Another {this.props.options.userAccountType === OCCUPANT_TYPE ? "Tenant" : "Member"}</span>
                </IonButton>)}
                {!this.state.tenantId && (<IonButton
                    type="submit"
                    size="lg"
                    style={{ width: "80%" }}
                    fill='outline'
                    className="mx-2 mt-3 py-1"
                    onClick={this.handleClear.bind(this)}
                >
                    Clear
                </IonButton>)}
            </Row>
        );
    }

    isValidDeposits(){
        let foundError = false;
        this.setState(prevState => {
            const depositsErrors = prevState.deposits.map((item, index) => {
                let nameError = "";
                let amountPaidError = "";
                if(!(item.name.length == 0 && item.amountPaid.length == 0)){
                    nameError = check_empty_field(item.name);
                    amountPaidError = check_empty_field(item.amountPaid) || check_if_number(item.amountPaid.toString());
                }
                if(!foundError){
                    foundError = nameError.length > 0 || amountPaidError.length > 0;
                }
                return {
                    name: nameError,
                    amountPaid: amountPaidError,
                    amountReturned: "",
                };
            });
            return {
                errors: {
                    ...prevState.errors,
                    deposits: depositsErrors
                }
            }
        });
        return !foundError;
    }


    getDepositName = (depositName) => ({id: depositName, label: depositName})

    handleChangeDepositNameOptions(index, selected){
        this.setState((prevState) => {
            let { deposits } = prevState;
            deposits[index]["name"] = selected;
            return {
                deposits
            };
        });
        this.isValidDeposits();
    }

    handleChangeDepositItem(index, key, event){
        event.preventDefault();
        this.setState((prevState) => {
            let {deposits} = prevState;
            deposits[index][key] = event.target.value;
            return {deposits}
        });
        this.isValidDeposits();
    }

    renderDeposit(){
         {/* Deposit */}
         return (<FormGroup row>
         <CustomLabel sm={12} md={3} for="deposit">
             Deposit (optional)
         </CustomLabel>

         <Col style={{minWidth: '200px', maxWidth: '450px'}} sm={12} md={8} className='mb-2'>
             {this.state.deposits.map( (deposit, index) => (
                <Row id={index.toString()} className='my-2' key={index.toString()}>
                    <Col sm={10}>
                        <Row>
                            <Col id={"depositTypeContainer" + index.toString()} sm={12} style={{minWidth:'200px'}}>
                                <span>Deposit Type</span>
                                <Typeahead
                                    clearButton
                                    disabled={this.state.readOnly}
                                    id={"depositName" + index.toString()}
                                    options={this.state.depositNameOptions}
                                    name="depositName"
                                    placeholder="deposit type ..."
                                    selected={deposit.name}
                                    onChange={this.handleChangeDepositNameOptions.bind(this, index)}
                                >
                                </Typeahead>
                                {this.state.errors.deposits[index].name.length > 0 &&
                                    <p className="text-danger">{this.state.errors.deposits[index].name}</p>
                                }
                            </Col>
                        </Row>

                        <Row className='mt-1'>

                            <Col lg={6} sm={6}>
                                <span>Amount Paid</span>
                                <InputGroup>

                                    <Input
                                        readOnly={this.state.readOnly}
                                        id={"amountPaid" + index.toString()}
                                        name="amountPaid"
                                        placeholder='amount paid ...'
                                        value={deposit.amountPaid}
                                        onChange={this.handleChangeDepositItem.bind(this, index, "amountPaid")}
                                        invalid={this.state.errors.deposits[index].amountPaid.length > 0}
                                    />
                                    <FormFeedback>{this.state.errors.deposits[index].amountPaid}</FormFeedback>
                                </InputGroup>
                            </Col>

                            <Col lg={6} sm={6}>
                                <span>Amount Returned</span>
                                <InputGroup>
                                    <Input
                                        readOnly={this.state.readOnly}
                                        id={"amountReturned" + index.toString()}
                                        name="amountReturned"
                                        placeholder='amount returned ...'
                                        value={deposit.amountReturned}
                                        onChange={this.handleChangeDepositItem.bind(this, index, "amountReturned")}
                                        invalid={this.state.errors.deposits[index].amountReturned.length > 0}
                                    />
                                    <FormFeedback>{this.state.errors.deposits[index].amountReturned}</FormFeedback>
                                </InputGroup>
                            </Col>
                        </Row>
                    </Col>

                    {(this.state.deposits.length-1) == index ? <Col className='mt-1' sm={1}>
                        <Button
                            outline color="secondary"
                            id={'addDepositButton' + index.toString()}
                            onClick={() => {
                                this.setState((prevState) => ({
                                    deposits: [...prevState.deposits, {name: [], amountPaid: "", amountReturned: ""}],
                                    errors: {
                                        ...prevState.errors,
                                        deposits: [
                                            ...prevState.errors.deposits,
                                            {name: "", amountPaid: "", amountReturned: ""}
                                        ]
                                    }
                                }))
                            }}
                        >
                            <IonIcon icon={addOutline} className="mr-1" />
                        </Button>
                    </Col> : (
                        <Col  className='mt-1' sm={1}>
                        <Button
                            outline color="secondary"
                            id={'removeDepositButton' + index.toString()}
                            disabled={this.state.readOnly}
                            onClick={() => {
                                this.setState((prevState) => ({
                                    deposits: prevState.deposits.filter(
                                        (item, itemIndex) => itemIndex != index
                                    ),
                                    errors: {
                                        ...prevState.errors,
                                        deposits: prevState.errors.deposits.filter(
                                            (item, itemIndex) => itemIndex != index
                                        )
                                    }
                                }))
                            }}
                        >
                            <IonIcon icon={trashOutline} />
                        </Button>
                    </Col>
                    )}
                </Row>
             ))}

         </Col>
     </FormGroup>);
    }

    renderAccountNumber(){
        return (
            <FormGroup row>
                <CustomLabel sm={12} md={3} for="email">
                    Account Number (optional)
                </CustomLabel>

                <Col style={{maxWidth: '450px'}} sm={12} md={8}>
                    <InputGroup>
                        <Input
                            id="accountId"
                            name="accountId"
                            placeholder="Account Number. ..."
                            value={this.state.accountId}
                            onChange={this.handleChange.bind(this)}
                            invalid={this.state.errors.accountId.length > 0}
                        />
                        <FormFeedback>{this.state.errors.accountId}</FormFeedback>
                    </InputGroup>
                    <p>Used when reconciling payments.</p>
                </Col>
            </FormGroup>
        );
    }

    renderNationalIdNumber(){
        return (
            <FormGroup row>
                <CustomLabel sm={12} md={3} for="email">
                    National ID (optional)
                </CustomLabel>

                <Col style={{maxWidth: '450px'}} sm={12} md={8}>
                    <InputGroup>
                        <Input
                            id="nationalIdNumber"
                            name="nationalIdNumber"
                            placeholder="National ID number ..."
                            value={this.state.nationalIdNumber}
                            onChange={this.handleChange.bind(this)}
                            invalid={this.state.errors.nationalIdNumber.length > 0}
                        />
                        <FormFeedback>{this.state.errors.nationalIdNumber}</FormFeedback>
                    </InputGroup>
                </Col>
            </FormGroup>
        );
    }

    renderkraPin(){
        return (
            <FormGroup row>
                <CustomLabel sm={12} md={3} for="taxPin">
                    Kra/Tax Pin (optional)
                </CustomLabel>

                <Col style={{maxWidth: '450px'}} sm={12} md={8}>
                    <InputGroup>
                        <Input
                            id="taxPin"
                            name="taxPin"
                            placeholder="Tax Pin ..."
                            value={this.state.taxPin}
                            onChange={this.handleChange.bind(this)}
                            invalid={this.state.errors.taxPin.length > 0}
                        />
                        <FormFeedback>{this.state.errors.taxPin}</FormFeedback>
                    </InputGroup>
                </Col>
            </FormGroup>
        );
    }

    renderEmail(){
        return (
            <FormGroup row>
                <CustomLabel sm={12} md={3} for="email">
                    Email (optional)
                </CustomLabel>

                <Col style={{maxWidth: '450px'}} sm={12} md={8}>
                    <InputGroup>
                        <Input
                            id="email"
                            name="email"
                            placeholder="Email ..."
                            value={this.state.email}
                            onChange={this.handleChange.bind(this)}
                            invalid={this.state.errors.email.length > 0}
                        />
                        <FormFeedback>{this.state.errors.email}</FormFeedback>
                    </InputGroup>
                </Col>
            </FormGroup>
        );
    }

    handleDeletePenalty = () => {
        this.setState({
          penaltyType: '',
          fixedPenaltyAmount: 0.00,
          percentagePenaltyAmount: 0.00,
          automaticallyPenalize: false,
          penaltyDayOfMonth: ''
        });
      };

    renderPenaltyField(){
        const FIXED_PENALTY = 'FIXED';
        const PERCENTAGE_PENALTY = 'PERCENTAGE';
        return (
            <FormGroup row>
                <CustomLabel sm={12} md={3} for="penalty">
                    Rent Payment Penalty (optional)
                </CustomLabel>

                <Col style={{maxWidth: '450px'}} sm={12} md={7}>
                    <CustomInput
                        type="select"
                        id="penaltyType"
                        name="penaltyType"
                        value={this.state.penaltyType}
                        onChange={this.handleChange}
                    >
                        <option key={""} value={""}>Select Penalty Type</option>
                        <option key={FIXED_PENALTY} value={FIXED_PENALTY}>Fixed Amount</option>
                        <option key={PERCENTAGE_PENALTY} value={PERCENTAGE_PENALTY}>Percentage of Rent</option>
                    </CustomInput>

                    {
                        (this.state.penaltyType != "") && (
                            <Row className="pb-3 mt-3">
                                <Row>
                                    <Col>
                                        {(this.state.penaltyType === FIXED_PENALTY) && (
                                            <FormGroup className="ml-3">
                                                <Label for="fixedPenaltyAmount">
                                                    Fixed Penalty Amount
                                                </Label>
                                                <IonIcon id="fixedPenaltyAmount" icon={informationCircleOutline} className="ml-2" />
                                                <Input
                                                    id="fixedPenaltyAmountInput"
                                                    name="fixedPenaltyAmount"
                                                    placeholder='0'
                                                    value={this.state.fixedPenaltyAmount}
                                                    onChange={this.handleChange}
                                                    invalid={this.state.errors.fixedPenaltyAmount.length > 0}
                                                />
                                                <UncontrolledTooltip placement="top" target="fixedPenaltyAmount">
                                                    A penalty of the entered amount will be charged on every {this.props.options.userAccountType === OCCUPANT_TYPE ? "tenant" : "member"} who pays their rent late
                                                </UncontrolledTooltip>
                                                <FormFeedback>{this.state.errors.fixedPenaltyAmount}</FormFeedback>
                                            </FormGroup>
                                        )}
                                        {(this.state.penaltyType === PERCENTAGE_PENALTY) && (
                                            <FormGroup className="ml-3">
                                                <Label for="percentagePenaltyAmount">
                                                    Percentage Penalty
                                                </Label>
                                                <IonIcon id="percentagePenaltyAmount" icon={informationCircleOutline} className="ml-2" />
                                                <Input
                                                    id="percentagePenaltyAmountInput"
                                                    name="percentagePenaltyAmount"
                                                    placeholder='0'
                                                    value={this.state.percentagePenaltyAmount}
                                                    onChange={this.handleChange}
                                                    invalid={this.state.errors.percentagePenaltyAmount.length > 0}
                                                />
                                                <UncontrolledTooltip placement="top" target="percentagePenaltyAmount">
                                                    A penalty of the entered percentage of the rent amount will be charged on every {this.props.options.userAccountType === OCCUPANT_TYPE ? "tenant" : "member"} who pays their rent late
                                                </UncontrolledTooltip>
                                                <FormFeedback>{this.state.errors.percentagePenaltyAmount}</FormFeedback>
                                            </FormGroup>
                                        )}
                                    </Col>
                                    {this.state.penaltyType !== '' && (
                                        <Col className="d-flex align-items-end mb-3 ml-3" style={{ maxWidth: '50px' }}>
                                          <Button outline color="secondary" onClick={() => this.handleDeletePenalty()}>
                                          <IonIcon icon={trashOutline} />
                                          </Button>
                                        </Col>
                                    )}
                                </Row>

                                {/* Automatically penalize */}
                                <Row>
                                    <Col className="ml-3" lg={12}>
                                        {
                                            <FormGroup>
                                                <Label check className="ml-3">
                                                    <Input
                                                        type="checkbox"
                                                        id="automaticallyPenalize"
                                                        name="automaticallyPenalize"
                                                        onChange={this.handleChange}
                                                        checked={this.state.automaticallyPenalize}
                                                    />{' '}
                                                    Automatically penalize {this.props.options.userAccountType === OCCUPANT_TYPE ? "tenants" : "members"} upon late payment <IonIcon icon={informationCircleOutline} id='automaticallyPenalize' className="ml-2" />
                                                </Label>
                                                <UncontrolledTooltip placement="top" target="automaticallyPenalize">
                                                    Automatically create late rent payment penalty invoices(bills) for each {this.props.options.userAccountType === OCCUPANT_TYPE ? "tenant" : "member"} on a certain date.
                                                </UncontrolledTooltip>
                                            </FormGroup>

                                        }

                                        {/* Penalty day of month */}
                                        {
                                            (this.state.automaticallyPenalize) && (
                                                <FormGroup row>
                                                    <Label for="penaltyDayOfMonth">
                                                        Penalty day of month
                                                        <IonIcon icon={informationCircleOutline} id='penaltyDayOfMonth' className="ml-2" />
                                                        <br/>
                                                        (When to apply the penalty)
                                                    </Label>

                                                    <CustomInput
                                                        type="select"
                                                        id="penaltyDayOfMonthInput"
                                                        name="penaltyDayOfMonth"
                                                        autoComplete="off"
                                                        placeholder=' penalty date ...'
                                                        value={this.state.penaltyDayOfMonth}
                                                        onChange={this.handleChange}
                                                        invalid={this.state.errors.penaltyDayOfMonth.length > 0}
                                                    >
                                                        <option key="empty" value={0}>{""}</option>
                                                        {this.state.penaltyDays.map((item, index) => (
                                                            <option key={item["value"]} value={item["value"]}>{item["day"]}</option>
                                                        ))}
                                                    </CustomInput>

                                                    <FormFeedback>{this.state.errors.penaltyDayOfMonth}</FormFeedback>
                                                </FormGroup>
                                            )
                                        }

                                    </Col>
                                </Row>
                            </Row>
                        )
                    }

                </Col>
            </FormGroup>
        );
    }

    renderNotes(){
        return (
            <FormGroup row>
                <CustomLabel sm={12} md={3} for="notes">
                    Notes (optional)
                </CustomLabel>

                <Col style={{maxWidth: '450px'}} sm={12} md={8}>
                    <InputGroup>
                        <Input
                            id="notes"
                            name="notes"
                            type="textarea"
                            placeholder='notes ...'
                            value={this.state.notes}
                            onChange={this.handleChange.bind(this)}
                            invalid={this.state.errors.notes.length > 0}
                        />
                        <FormFeedback>{this.state.errors.notes}</FormFeedback>
                    </InputGroup>
                </Col>
            </FormGroup>
        );
    }

    renderMoveInDate(){
        return (
            <FormGroup row>
                <CustomLabel sm={12} md={3} for="moveInDate">
                    Move In Date (optional)
                </CustomLabel>

                <Col style={{maxWidth: '450px'}} sm={12} md={8}>
                    <IonInput
                            id='moveInDate'
                            type="date"
                            fill="solid"
                            value={this.state.moveInDate}
                            onIonChange={(e) => {
                                const moveInDate = e.detail.value;
                                this.setState({ moveInDate });
                                this.validateInput("moveInDate", moveInDate);
                            }}
                        />
                    {this.state.errors.moveInDate && (
                        <div className="text-danger">{this.state.errors.moveInDate}</div>
                    )}
                </Col>
            </FormGroup>
        );
    }

    renderMoveOutDate(){
        return (
            <FormGroup row>
                <CustomLabel sm={12} md={3} for="moveOutDate">
                    Move Out Date (optional)
                </CustomLabel>

                <Col style={{maxWidth: '450px'}} sm={12} md={8}>
                    <IonInput
                            type="date"
                            id='moveOutDate'
                            fill="solid"
                            value={this.state.moveOutDate}
                            onIonChange={(e) => {
                                const moveOutDate = e.detail.value;
                                this.setState({ moveOutDate });
                                this.validateInput("moveOutDate", moveOutDate);
                            }}
                        />
                        {this.state.errors.moveOutDate && (
                            <div className="text-danger">{this.state.errors.moveOutDate}</div>
                        )}
                </Col>
            </FormGroup>
        )
    }

    renderLeaseStartDate(){
        return (
            <FormGroup row>
                <CustomLabel sm={12} md={3} for="leaseStartDate">
                    Lease Start Date (optional) <IonIcon id="leaseStartDate" icon={informationCircleOutline} style={{ fontSize: '30px' }}/>
                </CustomLabel>
                <UncontrolledTooltip placement="top" target="leaseStartDate">
                    If the {this.props.options.userAccountType === OCCUPANT_TYPE ? "tenant" : "member"} has a lease agreement, enter the start date here.
                </UncontrolledTooltip>

                <Col style={{maxWidth: '450px'}} sm={12} md={8}>
                    <IonInput
                            type="date"
                            id='leaseStartDateInput'
                            fill="solid"
                            value={this.state.leaseStartDate}
                            onIonChange={(e) => {
                                const leaseStartDate = e.detail.value;
                                this.setState({ leaseStartDate });
                                this.validateInput("leaseStartDate", leaseStartDate);
                            }}
                        />
                    {this.state.errors.leaseStartDate && (
                        <div className="text-danger">{this.state.errors.leaseStartDate}</div>
                    )}
                </Col>
            </FormGroup>
        )
    }

    renderLeaseEndDate(){
        return (
            <FormGroup row>
                <CustomLabel sm={12} md={3} for="leaseEndDate">
                    Lease End Date (optional) <IonIcon id="leaseEndDate" icon={informationCircleOutline} style={{ fontSize: '30px' }}/>
                </CustomLabel>
                <UncontrolledTooltip placement="top" target="leaseEndDate">
                    If the {this.props.options.userAccountType === OCCUPANT_TYPE ? "tenant" : "member"} has a lease agreement, enter the expiry date here.
                </UncontrolledTooltip>

                <Col style={{maxWidth: '450px'}} sm={12} md={8}>
                    <IonInput
                            type="date"
                            id='leaseEndDateInput'
                            fill="solid"
                            value={this.state.leaseEndDate}
                            onIonChange={(e) => {
                                const leaseEndDate = e.detail.value;
                                this.setState({ leaseEndDate });
                                this.validateInput("leaseEndDate", leaseEndDate);
                            }}
                        />
                    {this.state.errors.leaseEndDate && (
                        <div className="text-danger">{this.state.errors.leaseEndDate}</div>
                    )}
                </Col>
            </FormGroup>
        )
    }

    renderOtherPhoneNumbers(){
        return (
            <FormGroup row>
                <CustomLabel sm={12} md={3} for="otherPhoneNumbersFirstName">
                    Other phone numbers (optional)
                </CustomLabel>

                <Col style={{minWidth:'300px', maxWidth: '450px'}} sm={12} md={8}>
                    <p>first name and phone number are used when reconciling payments.</p>
                    {this.state.otherPhoneNumbers.map( (tenant_no, index) => (
                        <Row id={index.toString()} className='my-1 mt-2' key={index.toString()}>
                            <Col className='my-1' sm={12} xs={12} style={{minWidth:'140px', maxWidth:'200px'}}>
                                <InputGroup>
                                    <Input
                                        id={"otherPhoneNumbersInput" + index.toString()}
                                        name="otherPhoneNumberFirstName"
                                        placeholder='first name'
                                        value={tenant_no.firstName}
                                        onChange={this.handleOtherPhoneNoFirstName.bind(this, index)}
                                        invalid={this.state.errors.otherPhoneNumbers[index].firstName.length > 0}
                                    />
                                    <FormFeedback>{this.state.errors.otherPhoneNumbers[index].firstName}</FormFeedback>
                                </InputGroup>
                            </Col>

                            <Col className='my-1' sm={12} xs={12} style={{minWidth:'150px', maxWidth:'250px'}}>
                                <InputGroup id={'phoneInputGroupMainContainer' + index}>
                                    <FormattedPhoneInput
                                    key={index}
                                    index={index}
                                    country={'ke'}
                                    phoneNumber={this.state.otherPhoneNumbers[index].phoneNumber}
                                    onPhoneNumberChange={(index, value, formatted) => {
                                    this.setState((prevState) => {
                                        let otherPhoneNumbers = [...prevState.otherPhoneNumbers];
                                        otherPhoneNumbers[index].phoneNumber = value;
                                        otherPhoneNumbers[index].phoneNumberFormatted = formatted;
                                        return { otherPhoneNumbers };
                                    });
                                    }}
                                    fieldName={"otherPhoneNumber"}
                                    onPhoneNumberValidation={this.validateInput.bind(this)}
                                />

                                    <PhoneNumberFormatText/>
                                    <FormFeedback>{this.state.errors.otherPhoneNumbers[index].phoneNumber}</FormFeedback>
                                </InputGroup>
                            </Col>

                            {(this.state.otherPhoneNumbers.length-1) == index ?
                            (<Col className='mt-1' sm={1}>
                                <Button
                                    outline color="secondary"
                                    id={'addOtherPhoneNumbers' + index}
                                    onClick={() => {
                                        this.setState((prevState) => ({
                                            otherPhoneNumbers: [
                                                ...prevState.otherPhoneNumbers,
                                                {firstName: "", phoneNumber: "", phoneNumberFormatted: ""}],
                                            errors: {
                                                ...prevState.errors,
                                                otherPhoneNumbers: [
                                                    ...prevState.errors.otherPhoneNumbers,
                                                    {firstName: "", phoneNumber: "", phoneNumberFormatted: ""}
                                                ]
                                            }
                                        }))
                                    }}
                                >
                                    <IonIcon icon={addOutline} />
                                </Button>
                            </Col>) :
                            (<Col className='mt-1' sm={1}>
                                <Button
                                    outline color="secondary"
                                    id={'removeOtherPhoneNumbers' + index}
                                    onClick={() => {
                                        this.setState((prevState) => ({
                                            otherPhoneNumbers: prevState.otherPhoneNumbers.filter((item, itemIndex) => itemIndex != index),
                                            errors: {...prevState.errors, otherPhoneNumbers: prevState.errors.otherPhoneNumbers.filter((item, itemIndex) => itemIndex != index)}
                                        }));
                                    }}
                                >
                                    <IonIcon icon={trashOutline} />
                                </Button>
                            </Col>
                            )}
                    </Row>
                    ))}

                </Col>
            </FormGroup>
        );
    }
    
    renderNextOfKin(){
        return (
            <FormGroup row>
                <CustomLabel sm={12} md={3} for="nextOfKinName">
                    Next of Kin (optional)
                </CustomLabel>

                <Col style={{minWidth:'300px', maxWidth: '450px'}} sm={12} md={8}>
                    {this.state.nextOfKin.map((nok, index) => {
                        const rowErrors = (this.state.errors.nextOfKin && this.state.errors.nextOfKin[index]) || { name: "", phoneNumber: "" };
                        const hasRowError = (rowErrors.name?.length || 0) > 0 || (rowErrors.phoneNumber?.length || 0) > 0;
                        return (
                            <div key={index.toString()} className='border rounded p-2 mb-2'>
                                <Row className='align-items-center'>
                                    <Col>
                                        <span className='small' style={{color: 'var(--ion-color-medium)'}}>Next of Kin #{index + 1}</span>
                                    </Col>
                                    <Col className='text-right' style={{maxWidth:'60px'}}>
                                        <Button
                                            outline color="secondary"
                                            disabled={this.state.readOnly || this.state.nextOfKin.length === 1}
                                            onClick={() => {
                                                this.setState((prevState) => ({
                                                    nextOfKin: prevState.nextOfKin.filter((item, itemIndex) => itemIndex != index),
                                                    errors: {
                                                        ...prevState.errors,
                                                        nextOfKin: (prevState.errors.nextOfKin || []).filter((item, itemIndex) => itemIndex != index)
                                                    }
                                                }), this.isValidNextOfKin.bind(this));
                                            }}
                                        >
                                            <IonIcon icon={trashOutline} />
                                        </Button>
                                    </Col>
                                </Row>

                                <Row className='mt-2'>
                                    <Col md={6} sm={12} xs={12} className='mb-2'>
                                        <span className='small' style={{color: 'var(--ion-color-medium)'}}>Name</span>
                                        <InputGroup>
                                            <Input
                                                id={`nextOfKinName${index}`}
                                                name="nextOfKinName"
                                                placeholder='Name'
                                                value={nok.name}
                                                onChange={(e)=>{
                                                    this.setState((prevState)=>{
                                                        let nextOfKin = [...prevState.nextOfKin];
                                                        nextOfKin[index].name = e.target.value;
                                                        return { nextOfKin };
                                                    }, this.isValidNextOfKin.bind(this))
                                                }}
                                            />
                                        </InputGroup>
                                    </Col>
                                    <Col md={6} sm={12} xs={12} className='mb-2'>
                                        <span className='small' style={{color: 'var(--ion-color-medium)'}}>Phone</span>
                                        <InputGroup>
                                            <FormattedPhoneInput
                                                key={`nok-${index}`}
                                                index={index}
                                                country={'ke'}
                                                phoneNumber={this.state.nextOfKin[index].phoneNumber}
                                                onPhoneNumberChange={(i, value, formatted) => {
                                                    this.setState((prevState) => {
                                                        let nextOfKin = [...prevState.nextOfKin];
                                                        nextOfKin[index].phoneNumber = value;
                                                        nextOfKin[index].phoneNumberFormatted = formatted;
                                                        return { nextOfKin };
                                                    }, this.isValidNextOfKin.bind(this));
                                                }}
                                                fieldName={"nextOfKinPhoneNumber"}
                                            />
                                        </InputGroup>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={6} sm={12} xs={12} className='mb-2'>
                                        <span className='small' style={{color: 'var(--ion-color-medium)'}}>Relationship</span>
                                        <InputGroup>
                                            <Input
                                                id={`nextOfKinRelationship${index}`}
                                                name="nextOfKinRelationship"
                                                placeholder='Relationship'
                                                value={nok.relationship || ''}
                                                onChange={(e)=>{
                                                    this.setState((prevState)=>{
                                                        let nextOfKin = [...prevState.nextOfKin];
                                                        nextOfKin[index].relationship = e.target.value;
                                                        return { nextOfKin };
                                                    });
                                                }}
                                            />
                                        </InputGroup>
                                    </Col>
                                    <Col md={6} sm={12} xs={12} className='mb-2'>
                                        <span className='small' style={{color: 'var(--ion-color-medium)'}}>Other info</span>
                                        <InputGroup>
                                            <Input
                                                id={`nextOfKinInfo${index}`}
                                                name="nextOfKinInformation"
                                                placeholder='Other information'
                                                value={nok.information || ''}
                                                onChange={(e)=>{
                                                    this.setState((prevState)=>{
                                                        let nextOfKin = [...prevState.nextOfKin];
                                                        nextOfKin[index].information = e.target.value;
                                                        return { nextOfKin };
                                                    });
                                                }}
                                            />
                                        </InputGroup>
                                    </Col>
                                </Row>
                                {hasRowError && (
                                    <Row className='mt-1'>
                                        <Col md={12}>
                                            <div className='p-2 bg-light text-danger small'>
                                                {(rowErrors.name || "")} {rowErrors.phoneNumber && (rowErrors.name ? " | " : "")} {(rowErrors.phoneNumber || "")}
                                            </div>
                                        </Col>
                                    </Row>
                                )}
                            </div>
                        );
                    })}

                    <div className='d-flex'>
                        <Button
                            outline color="secondary"
                            disabled={this.state.readOnly}
                            onClick={() => {
                                this.setState((prevState) => ({
                                    nextOfKin: [
                                        ...prevState.nextOfKin,
                                        {name: "", phoneNumber: "", phoneNumberFormatted: "", relationship: "", information: ""}
                                    ],
                                    errors: {
                                        ...prevState.errors,
                                        nextOfKin: [
                                            ...(prevState.errors.nextOfKin || []),
                                            {name: "", phoneNumber: "", phoneNumberFormatted: "", relationship: "", information: ""}
                                        ]
                                    }
                                }), this.isValidNextOfKin.bind(this))
                            }}
                        >
                            <IonIcon icon={addOutline} />
                        </Button>
                    </div>
                </Col>
            </FormGroup>
        )
    }
    renderBankPayerNames() {
        return (
            <FormGroup row>
                <CustomLabel sm={12} md={3} for="bankPayerNames">
                    Bank Payer Names (optional) <IonIcon id="bpLabel" icon={informationCircleOutline} style={{ fontSize: '30px' }}/>
                </CustomLabel>
                <UncontrolledTooltip placement="top" target="bpLabel">
                    Use this field to include all possible names of people who may pay for this {this.props.options.userAccountType === OCCUPANT_TYPE ? "tenant" : "member"} so that the system automatically assigns the payment correctly.
                </UncontrolledTooltip>

                <Col style={{ minWidth: '300px', maxWidth: '450px' }} sm={12} md={8}>
                    {this.state.bankPayerNames.map((p_name, index) => (
                        <InputGroup key={index}>
                            <Input
                                id={`bankPayerNames` + index}
                                name="bankPayerNames"
                                placeholder="Enter Full Name ..."
                                value={p_name}
                                onChange={this.handleBankPayerNames.bind(this, index)}
                            />
                            {(this.state.bankPayerNames.length - 1) === index ? (
                                <Col className='mt-1' sm={1}>
                                    <Button
                                        outline color="secondary"
                                        id={`addBankPayerNames` + index}
                                        onClick={() => {
                                            this.setState((prevState) => ({
                                                bankPayerNames: [
                                                    ...prevState.bankPayerNames,
                                                    ''
                                                ]
                                            }));
                                        }}
                                    >
                                        <IonIcon icon={addOutline} />
                                    </Button>
                                </Col>
                            ) : (
                                <Col className='mt-1' sm={1}>
                                    <Button
                                        outline color="secondary"
                                        id={`removeBankPayerNames` + index}
                                        onClick={() => {
                                            this.setState((prevState) => ({
                                                bankPayerNames: prevState.bankPayerNames.filter(
                                                    (item, itemIndex) => itemIndex !== index
                                                )
                                            }));
                                        }}
                                    >
                                        <IonIcon icon={trashOutline} />
                                    </Button>
                                </Col>
                            )}
                        </InputGroup>
                    ))}
                </Col>
            </FormGroup>
        );
    }

    renderFileUpload(){
        return (
            <FormGroup row>
                <CustomLabel sm={12} md={3} for="fileUpload">
                    File upload (optional)
                </CustomLabel>

                <Col style={{maxWidth: '450px'}} sm={12} md={8}>
                    <UploadFile
                        fileName={this.state.fileName}
                        file={this.state.file}
                        noShowLabel={true}
                        label={"File upload (optional"}
                        handleDownloadFile={this.handleDownloadFile.bind(this)}
                        handleChangeFile={this.handleChangeFile.bind(this)}
                        handleClose={this.handleClose.bind(this)}
                    />
                    <p>File can be lease agreement, or any other {this.props.options.userAccountType === OCCUPANT_TYPE ? "tenant" : "member"} document</p>
                </Col>
            </FormGroup>
        );
    }

    renderOptionalFields(){
        return (
            <React.Fragment>
                {/* Different types of depoists */}
                {this.renderDeposit()}

                {/* Account Number */}
                {this.renderAccountNumber()}

                {/* National ID Number */}
                {this.renderNationalIdNumber()}

                {/* Email */}
                {this.renderEmail()}

                {/* kraPin/taxPin */}
                {this.renderkraPin()}

                {/** Penalty */}
                {this.renderPenaltyField()}

                {/* notes */}
                {this.renderNotes()}

                {/* Move In Date */}
                {this.renderMoveInDate() }

                {/* Move Out Date */}
                { this.renderMoveOutDate() }

                {/* Lease Start Date */}
                { this.renderLeaseStartDate() }

                {/* Lease End Date */}
                { this.renderLeaseEndDate() }

                {/* Other phone numbers */}
                {this.renderOtherPhoneNumbers()}

                {/* Next of Kin */}
                {this.renderNextOfKin()}

                {/* Bank Payer Names */}
                {this.renderBankPayerNames()}

                {/* File Upload */}
                {this.renderFileUpload()}

            </React.Fragment>
        );
    }

    renderTenantPageButton(){
        return(
            <Button className="mx-2 bg-white"
                style={{borderColor: colorTheme["primary"]["700"], color: colorTheme["primary"]["700"], animation: 'pulse 2s 3'}}
                onClick={this.handleTenantPageButton.bind(this)}
                data-testid="viewTenantPageButton"
            >
                View {this.props.options.userAccountType === OCCUPANT_TYPE ? "Tenant" : "Member"}(s){" "}
                <IonIcon icon={arrowForwardOutline} className="mr-2" />
            </Button>
        )
    }

    render() {

        const { location } = this.props;

        const isUrlNavigation = location.pathname === UNIFORM_RESOURCE_LOCATORS.tenantForm;

        return (
            <Container>
                {isUrlNavigation && (<Row className="d-flex justify-content-start">
                    <Col lg={9} className="mb-3">
                        {this.renderBackButton()}
                    </Col>
                </Row>)}

                <Row className="mb-3">
                    <Col lg={3} md={4} sm={3} xs={3}>
                    {this.state.tenantId && (
                        <IonButton
                            size="large"
                            color="secondary"
                            className="mx-2 shadow"
                            id="deleteButton"
                            onClick={this.handleDelete.bind(
                            this,
                            this.state.propertyId,
                            this.state.unitId,
                            this.state.tenantId
                            )}
                            disabled={this.state.readOnly}
                            data-testid="deleteButton"
                        >
                            <IonIcon icon={trashOutline} />
                        </IonButton>
                    )}
                    </Col>
                </Row>

                {this.state.showAlert && (
                    <div className="alert alert-success">
                        Add a {this.props.options.userAccountType === OCCUPANT_TYPE ? "Tenant" : "Member"} in order to complete On boarding.
                        <button type="button" className="close" onClick={this.handleAlertClose}>
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                )}

                <Row>
                    <Col className='mx-1' lg={12}>
                        <Form onSubmit={this.handleSubmit.bind(this)}>


                            {this.renderRequiredFields()}

                            <ShowMoreButton
                                id="showOptionalFields"
                                onClick={(e) => {
                                    e.preventDefault();
                                    this.setState((prevState) => ({showOptionalFields: !prevState.showOptionalFields}))
                                }}
                                showMore={this.state.showOptionalFields}
                            />

                        {this.state.showOptionalFields && this.renderOptionalFields()}


                        {this.renderButtons()}


                        </Form>
                    </Col>
                </Row>

                <Row className="d-flex justify-content-end">
                    {this.state.tenantId && this.state.showAlert && this.renderTenantPageButton()}
                </Row>

                {isUrlNavigation && (<Row className="d-flex justify-content-start">
                    <Col lg={9} className="mb-3">
                        {this.renderBackButton()}
                    </Col>
                </Row>)}
            </Container>
        );
    }
}

export default withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
)(TenantForm));